import { Environment, Network, RecordSource, Store } from "relay-runtime";
import _ from "underscore";
import { SubscriptionClient } from "subscriptions-transport-ws";

import auth from "./helpers/auth";
import { SERVER_WS_URL } from "./constants";

function fetchQuery(operation, variables, cacheConfig, uploadables = []) {
  let requestVariables = {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
  };
  const token = auth.getToken();
  let body;
  if (!_.isEmpty(uploadables)) {
    if (!window.FormData) {
      throw new Error("Uploading files without `FormData` not supported.");
    }
    const formData = new FormData();
    formData.append("query", operation.text);
    formData.append("variables", JSON.stringify(variables));
    Object.keys(uploadables).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(uploadables, key)) {
        if (Array.isArray(uploadables[key])) {
          uploadables[key].map((file, index) => {
            formData.append(key, file);
            return null;
          });
        } else formData.append(key, uploadables[key]);
      }
    });
    body = formData;
  } else {
    requestVariables.headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    body = JSON.stringify({
      query: operation.text,
      variables,
    });
  }
  if (token) {
    requestVariables.headers["Authorization"] = `JWT ${token}`;
  }
  return fetch("/graphql", {
    ...requestVariables,
    body,
  }).then((response) => {
    return response.json();
  });
}

const setupSubscription = (config, variables, cacheConfig, observer) => {
  const query = config.text;

  const subscriptionClient = new SubscriptionClient(SERVER_WS_URL, {
    reconnect: true,
  });
  const client = subscriptionClient.request({ query, variables }).subscribe({
    next: (result) => {
      observer.onNext({ data: result.data });
    },
    complete: () => {
      observer.onCompleted();
    },
    error: (error) => {
      observer.onError(error);
    },
  });

  return {
    dispose: client.unsubscribe,
  };
};

const environment = new Environment({
  network: Network.create(fetchQuery, setupSubscription),
  store: new Store(new RecordSource()),
});

export default environment;



// WEBPACK FOOTER //
// ./src/Network.js